import { lazy } from 'react'

export default lazy(
    () => 
    import('./FreightViewB2B') 
)